/**
 * Permissions guide — controlling tool access with approval modes and policies.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { permissionsGuideContent } from "@/constants/docs/permissions-guide";

export const Route = createFileRoute("/docs/permissions")({
	component: PermissionsPage,
});

function PermissionsPage() {
	return <DocsPage title="Permissions" content={permissionsGuideContent} />;
}
